import { Component, Input, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-material-pg-input',
  templateUrl: './material-pg-input.component.html',
  imports: [SharedModule, MatInputModule, MatFormFieldModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MaterialPgInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MaterialPgInputComponent),
      multi: true,
    },
  ],
})

export class MaterialPgInputComponent implements ControlValueAccessor, Validator {
  onChange: (value: string | number) => void = () => {};
  onTouched = () => { };
  @Input() id: string | undefined;

  @Input() set label(value: string) {
    if (value) {
      this._label = value;
    }
  }

  @Input() set disabled(value: boolean) {
    this._disabled = value;
  }

  @Input() set type(value: string) {
    this._type = value;
  }
  @Input() required = false;

  _disabled: boolean = false;
  _valid = false;
  _value: string | number = '';
  _label = '';
  _type = '';

  writeValue(value: any): void {
    this._value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  valueChanged(event: Event): void {
    const input = event.target as HTMLInputElement;
    this._value = (this._type === 'number') ? input.valueAsNumber : input.value;
    this.onChange(this._value);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.required && !control.value) {
      return { required: true };
    }
    return null;
  }

}
